import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Shield, Sparkles } from "lucide-react";
import { useDeviceType } from "@/hooks/use-device-type";

export function MobileHeroSection() {
  const { isLandscape } = useDeviceType();

  if (isLandscape) {
    return (
      <div className="flex items-start gap-6 py-2">
        {/* Left: Text */}
        <div className="flex-1 space-y-2">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary/10 border border-primary/20">
            <Shield className="w-3 h-3 text-primary" />
            <span className="text-xs font-medium text-primary">Rechtskonform in Minuten</span>
          </div>
          <h1 className="text-lg font-bold leading-tight text-foreground">
            Speisen- und Getränkekarten{" "}
             <span className="text-primary">rechtskonform prüfen</span>
          </h1>
          <p className="text-muted-foreground text-xs leading-relaxed">
            Automatische LMIV-Prüfung mit KI. Allergene, Zusatzstoffe und rechtliche Hinweise in max. 4 Minuten.
          </p>
        </div>
        {/* Right: CTAs */}
        <div className="flex flex-col gap-2 min-w-[160px]">
          <Button size="sm" className="w-full font-semibold" asChild>
            <Link to="/speisekarte-hochladen">
              <Sparkles className="w-3 h-3 mr-1" />
              Jetzt prüfen
              <ArrowRight className="w-3 h-3 ml-1" />
            </Link>
          </Button>
          <Button variant="outline" size="sm" className="w-full" asChild>
            <Link to="/demo">Demo ansehen</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center space-y-6 pt-6 pb-4">
      <div className="space-y-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
          <Shield className="w-4 h-4 text-primary" />
          <span className="text-sm font-medium text-primary">Rechtskonform in Minuten</span>
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold leading-tight text-foreground">
          Speisen- und Getränkekarten<br />
          <span className="text-primary">rechtskonform prüfen</span>
        </h1>
        <p className="text-muted-foreground leading-relaxed text-sm sm:text-base px-2">
          Automatische LMIV-Prüfung mit KI. Allergene, Zusatzstoffe und rechtliche Hinweise in max. 4 Minuten.
        </p>
      </div>
      <div className="flex flex-col gap-3 px-4">
        <Button size="lg" className="w-full touch-target font-semibold" asChild>
          <Link to="/speisekarte-hochladen">
            <Sparkles className="w-4 h-4 mr-2" />
            Jetzt prüfen
            <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </Button>
        <Button variant="outline" size="lg" className="w-full touch-target" asChild>
          <Link to="/demo">Demo ansehen</Link>
        </Button>
      </div>
    </div>
  );
}
